import { render, staticRenderFns } from "./GovHome.vue?vue&type=template&id=7b1d4a1d&"
import script from "./GovHome.vue?vue&type=script&lang=js&"
export * from "./GovHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports